import React from 'react';
import { connect } from 'react-redux';
import filterConnect from '../../../../common/hoc/filterConnect';
const Role = filterConnect(
  ({ getDescription, fieldsValue, roles }) => {
    let val = getDescription(fieldsValue, { roles });
    return val ? val : null;
  },
  ['roles']
);

const DataForACBPDP = filterConnect(
  ({ getDescription, fieldsValue, citizenships }) => {
    let val = getDescription(fieldsValue, { citizenships });
    return val ? val : null;
  },
  ['citizenships']
);

const ServiceType = filterConnect(
  ({ getDescription, fieldsValue, serviceTypes }) => {
    let val = getDescription(fieldsValue, { serviceTypes });
    return val ? val : null;
  },
  ['serviceTypes']
);

// todo удалить и использовать с общим названием ServiceType
const OfferInfo = filterConnect(
  ({ getDescription, fieldsValue, serviceTypes }) => {
    let val = getDescription(fieldsValue, { serviceTypes });
    return val ? val : null;
  },
  ['serviceTypes']
);

const OtherUserInfo = filterConnect(
  ({ getDescription, fieldsValue, foreignLanguages }) => {
    let val = getDescription(fieldsValue, { foreignLanguages });
    return val ? val : null;
  },
  ['foreignLanguages']
);

const RequestStatus = filterConnect(
  ({ getDescription, fieldsValue, requestStatuses }) => {
    let val = getDescription(fieldsValue, { requestStatuses });
    return val ? val : null;
  },
  ['requestStatuses']
);

const Customer = connect(state => ({
  customerCompanies:
    state.Common.ProfileFields.customerCompanies &&
    state.Common.ProfileFields.customerCompanies.all,
  activeProfile: state.Authorization.activeProfile,
}))(({ getDescription, fieldsValue, customerCompanies, activeProfile }) => {
  let val = getDescription(fieldsValue, { customerCompanies, activeProfile });
  return val ? val : null;
});

const OrderStatus = filterConnect(
  ({ getDescription, fieldsValue, orderStatuses }) => {
    let val = getDescription(fieldsValue, { orderStatuses });
    return val ? val : null;
  },
  ['orderStatuses']
);

const OfferStatus = filterConnect(
  ({ getDescription, fieldsValue, orderStatuses }) => {
    let val = getDescription(fieldsValue, { orderStatuses });
    return val ? val : null;
  },
  ['orderStatuses']
);

// const Customer = filterConnect(
//   ({getDescription, fieldsValue, subjects}) => {
//     let val = getDescription(fieldsValue, { subjects });
//     debugger
//   }
// )

const progressDescription = ({ name, getDescription, fieldsValue }) => {
  if (!getDescription) return null;
  switch (name) {
    case 'customer':
      return (
        <Customer getDescription={getDescription} fieldsValue={fieldsValue} />
      );
    case 'requestStatus':
      return (
        <RequestStatus
          getDescription={getDescription}
          fieldsValue={fieldsValue}
        />
      );
    // case 'customer':
    //   return <Customer getDescription={getDescription} fieldsValue={fieldsValue} />
    case 'offerInfo':
      return (
        <OfferInfo getDescription={getDescription} fieldsValue={fieldsValue} />
      );
    case 'serviceType':
      return (
        <ServiceType
          getDescription={getDescription}
          fieldsValue={fieldsValue}
        />
      );
    case 'offerStatus':
      return  (
        <OfferStatus
          getDescription={getDescription}
          fieldsValue={fieldsValue}
        />
      );
    case 'orderStatus':
      return (
        <OrderStatus
          getDescription={getDescription}
          fieldsValue={fieldsValue}
        />
      );
    case 'role':
      return <Role getDescription={getDescription} fieldsValue={fieldsValue} />;
    case 'dataForACBPDP':
      return (
        <DataForACBPDP
          getDescription={getDescription}
          fieldsValue={fieldsValue}
        />
      );
    case 'otherInfo':
      return (
        <OtherUserInfo
          getDescription={getDescription}
          fieldsValue={fieldsValue}
        />
      );
    case 'photoDriverLicense':
      return null;
    default:
      return getDescription(fieldsValue);
  }
};

export default progressDescription;
